import { ViewMode } from "../components/shared";

const STORAGE_KEY_PREFIX = "admin_viewMode_";

export const viewModeStorage = {
  /**
   * Save viewMode to localStorage for a specific page
   */
  save: (pageKey: string, viewMode: ViewMode): void => {
    try {
      localStorage.setItem(`${STORAGE_KEY_PREFIX}${pageKey}`, viewMode);
    } catch (error) {
      console.warn("Failed to save viewMode to localStorage:", error);
    }
  },

  /**
   * Load viewMode from localStorage for a specific page
   * @param pageKey - The unique key for the page (e.g., 'clients', 'professionals', 'services')
   * @param defaultValue - Default viewMode to return if nothing is stored
   */
  load: (pageKey: string, defaultValue: ViewMode = "grid"): ViewMode => {
    try {
      const stored = localStorage.getItem(`${STORAGE_KEY_PREFIX}${pageKey}`);
      if (stored && (stored === "grid" || stored === "list")) {
        return stored;
      }
    } catch (error) {
      console.warn("Failed to load viewMode from localStorage:", error);
    }
    return defaultValue;
  },

  /**
   * Clear viewMode from localStorage for a specific page
   */
  clear: (pageKey: string): void => {
    try {
      localStorage.removeItem(`${STORAGE_KEY_PREFIX}${pageKey}`);
    } catch (error) {
      console.warn("Failed to clear viewMode from localStorage:", error);
    }
  },

  /**
   * Clear all viewMode data from localStorage
   */
  clearAll: (): void => {
    try {
      const keys = Object.keys(localStorage).filter((key) =>
        key.startsWith(STORAGE_KEY_PREFIX)
      );
      keys.forEach((key) => localStorage.removeItem(key));
    } catch (error) {
      console.warn("Failed to clear all viewModes from localStorage:", error);
    }
  },
};
